import { useRecoilState } from 'recoil'

import { Wrapper, AppBarR as PersistentDrawerRight } from '../components/common'
import { EditOffice } from '../components/office'
import { sessionState } from '../state'

const EditOfficePage = () => {
  const [userState] = useRecoilState(sessionState)
  console.log('render')
  return (
    <>
      <PersistentDrawerRight></PersistentDrawerRight>
      <Wrapper>{userState.user && <EditOffice />}</Wrapper>
    </>
  )
}

export default EditOfficePage
